import React from 'react';
import ModalFormUI from '../../../../widgets/form/ModalFormUI';
import InputTextAreaSF from '../../../../widgets/form/InputTextAreaSF'

const CSInternalEmailModalUI = ({
  context, successMsg, errorList,
  // modes
  sendMode, submitted,
  // event handlers
  onSubmit, onCancelClick, setErrorList,
  //
  emailMessage, onEmailMessageChange, emailMessageError, setEmailMessageError


}) =>
  <ModalFormUI
    context={context}
    titleLabel='Internal Email'
    buttonLabel='Send'
    cancelLabel='Cancel'
    isOpen={sendMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    setErrorList={setErrorList}
    errorList={errorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    {/* <InputTextAreaSF type='text' name='message' label='Message'
      value={emailMessage} onChange={onEmailMessageChange}
      error={emailMessageError} setError={setEmailMessageError}
      maxLength={500}
    /> */}
  </ModalFormUI>

export default CSInternalEmailModalUI;
